(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bbqr-gift-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Shipping and course labels use Europe/Berlin, independently of the browser.
    const berlinDateFormatter = new Intl.DateTimeFormat("en-GB", {
      timeZone: "Europe/Berlin", year: "numeric", month: "2-digit", day: "2-digit",
      hour: "2-digit", minute: "2-digit", second: "2-digit", hourCycle: "h23",
    });
    const berlinParts = (timestamp) => Object.fromEntries(
      berlinDateFormatter.formatToParts(timestamp)
        .filter((part) => part.type !== "literal")
        .map((part) => [part.type, Number(part.value)])
    );
    const isoFromParts = (parts) => `${parts.year}-${String(parts.month).padStart(2, "0")}-${String(parts.day).padStart(2, "0")}`;
    const shiftISODate = (iso, days) => {
      const [year, month, day] = iso.split("-").map(Number);
      const shifted = new Date(Date.UTC(year, month - 1, day + days, 12));
      return isoFromParts({ year: shifted.getUTCFullYear(), month: shifted.getUTCMonth() + 1, day: shifted.getUTCDate() });
    };
    const localISODate = (daysFromToday = 0) => shiftISODate(isoFromParts(berlinParts(Date.now())), daysFromToday);
    const validCalendarDate = (year, month, day) => {
      const date = new Date(Date.UTC(year, month - 1, day, 12));
      return date.getUTCFullYear() === year && date.getUTCMonth() + 1 === month && date.getUTCDate() === day;
    };
    const berlinTimestamp = (year, month, day, hour, minute) => {
      if (!validCalendarDate(year, month, day)) return null;
      const encodedWallTime = Date.UTC(year, month - 1, day, hour, minute);
      const offsets = new Set([-36, 0, 36].map((hours) => {
        const probe = encodedWallTime + hours * 3600000;
        const parts = berlinParts(probe);
        return Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second) - probe;
      }));
      const candidates = Array.from(offsets).map((offset) => encodedWallTime - offset).filter((timestamp) => {
        const parts = berlinParts(timestamp);
        return parts.year === year && parts.month === month && parts.day === day && parts.hour === hour && parts.minute === minute;
      });
      // Missing and duplicated local hours around DST changes are not guessed.
      return candidates.length === 1 ? candidates[0] : null;
    };
    const parseCourseBegin = (label) => {
      const snapshot = String(label || "");
      const match = snapshot.match(/^[ ]*(?:📅|🗓️)[ ]*(Montag|Dienstag|Mittwoch|Donnerstag|Freitag|Samstag|Sonntag)[ ]+([0-9]{2})[.]([0-9]{2})[.]([0-9]{4})[ ]+(?:🕐|🕑|🕒|🕓|🕔|🕕|🕖|🕗|🕘|🕙|🕚|🕛)[ ]*([01]?[0-9]|2[0-3]):([0-5][0-9])[ ]*Uhr[ ]*(?:🔥)?[ ]*$/);
      // Require the complete known snapshot grammar, including no trailing newline or timezone suffix.
      if (!match || match[0] !== snapshot) return null;
      const [day, month, year, hour, minute] = match.slice(2).map(Number);
      if (!validCalendarDate(year, month, day)) return null;
      const weekdays = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];
      if (weekdays[new Date(Date.UTC(year, month - 1, day, 12)).getUTCDay()] !== match[1]) return null;
      const timestamp = berlinTimestamp(year, month, day, hour, minute);
      // An unknown or ambiguous course start blocks fixed gifts; there is no date-only fallback.
      return timestamp === null || timestamp <= 0 ? null : { timestamp, date: isoFromParts({ year, month, day }), hasExactTime: true };
    };

    const pruneFixedCourseChoices = (root, now = Date.now()) => {
      let remainingCount = 0;
      root.querySelectorAll("[data-bbqr-course-card]").forEach((card) => {
        const remaining = Array.from(card.querySelectorAll("[data-bbqr-fixed-option]")).filter((option) => {
          const begin = parseCourseBegin(option.dataset.date);
          if (begin && begin.timestamp > now) return true;
          option.remove();
          return false;
        });
        if (remaining.length === 0) {
          card.remove();
          return;
        }
        remainingCount += remaining.length;
        remaining.forEach((option, index) => {
          option.hidden = index >= 3;
          option.toggleAttribute("data-bbqr-extra-date", index >= 3);
        });
        const more = card.querySelector("[data-bbqr-more-dates]");
        if (more) {
          const extraCount = Math.max(0, remaining.length - 3);
          more.hidden = extraCount === 0;
          more.setAttribute("aria-expanded", "false");
          more.dataset.moreLabel = extraCount === 1
            ? more.dataset.moreOneLabel || ""
            : (more.dataset.moreManyLabel || "").replace("__COUNT__", String(extraCount));
          more.textContent = more.dataset.moreLabel;
        }
      });
      const choices = root.querySelector("[data-bbqr-fixed-courses]");
      if (choices) {
        choices.dataset.fixedCourseCount = String(remainingCount);
        choices.hidden = remainingCount === 0;
      }
      const fixedButton = root.querySelector("[data-bbqr-mode-fixed]");
      if (fixedButton) fixedButton.disabled = remainingCount === 0;
    };

    const initializeGiftSection = (root) => {
      if (!root || root.dataset.bbqrInitialized === "true") return;

      root.dataset.bbqrInitialized = "true";

      const form = root.querySelector(".bbqr-gift-form");
      if (!form) return;

      const formatInputs = Array.from(form.querySelectorAll("[data-bbqr-format]"));
      const deliveryInputs = Array.from(form.querySelectorAll("[data-bbqr-delivery]"));
      const timingInputs = Array.from(form.querySelectorAll("[data-bbqr-timing]"));
      const previewPanels = Array.from(root.querySelectorAll("[data-bbqr-preview]"));
      const previewKinds = Array.from(root.querySelectorAll("[data-bbqr-preview-kind]"));
      const directPanel = form.querySelector("[data-bbqr-direct]");
      const recipientEmail = form.querySelector("[data-bbqr-recipient-email]");
      const dateWrap = form.querySelector("[data-bbqr-date-wrap]");
      const dateInput = form.querySelector("[data-bbqr-date]");
      const configuredMaxScheduleDays = Number.parseInt(dateInput?.dataset.maxDays || "90", 10);
      const maxScheduleDays = Number.isFinite(configuredMaxScheduleDays) ? configuredMaxScheduleDays : 90;
      const messageInput = form.querySelector("[data-bbqr-message]");
      const messageCount = form.querySelector("[data-bbqr-message-count]");
      const forNameInput = form.querySelector("[data-bbqr-for-name]");
      const fromNameInput = form.querySelector("[data-bbqr-from-name]");
      const previewForNames = Array.from(root.querySelectorAll("[data-bbqr-preview-for]"));
      const previewFromNames = Array.from(root.querySelectorAll("[data-bbqr-preview-from]"));
      const summary = form.querySelector(".bbqr-gift-form__summary");
      const submitButton = form.querySelector(".bbqr-gift-submit");
      const trimRequiredInputs = Array.from(form.querySelectorAll("[data-bbqr-trim-required]"));
      const variantInput = form.querySelector("[data-bbqr-variant-id]");
      const giftTypeInput = form.querySelector("[data-bbqr-gift-type]");
      const productIdInput = form.querySelector('[name="product-id"]');
      const flexibleMode = form.querySelector("[data-bbqr-flexible-mode]");
      const fixedMode = form.querySelector("[data-bbqr-fixed-mode]");
      const selectedCourse = form.querySelector("[data-bbqr-selected-course]");
      const selectedDetails = form.querySelector("[data-bbqr-selected-details]");
      const selectedDate = form.querySelector("[data-bbqr-selected-date]");
      const selectedPrice = form.querySelector("[data-bbqr-selected-price]");
      const selectedStock = form.querySelector("[data-bbqr-selected-stock]");
      const selectedCopy = form.querySelector("[data-bbqr-selected-copy]");
      const courseActions = form.querySelector("[data-bbqr-course-actions]");
      const purchaseLead = root.querySelector("[data-bbqr-purchase-lead]");
      const priceLabel = root.querySelector("[data-bbqr-price-label]");
      const priceValue = root.querySelector("[data-bbqr-price]");
      pruneFixedCourseChoices(root);
      const fixedCourseSelectors = Array.from(root.querySelectorAll("[data-bbqr-fixed-option]"));
      const fixedCourseConfirmButtons = Array.from(root.querySelectorAll("[data-bbqr-fixed-confirm]"));
      const fixedCourseMoreButtons = Array.from(root.querySelectorAll("[data-bbqr-more-dates]"));
      const flexibleModeButton = form.querySelector("[data-bbqr-mode-flexible]");
      const fixedModeButton = form.querySelector("[data-bbqr-mode-fixed]");
      const changeCourseButton = form.querySelector("[data-bbqr-change-course]");
      const removeCourseButton = form.querySelector("[data-bbqr-remove-course]");
      const fixedCourses = root.querySelector("[data-bbqr-fixed-courses]");
      const previewBlock = root.querySelector("[data-bbqr-preview-block]");
      const previewHome = root.querySelector("[data-bbqr-preview-home]");
      const previewMobileSlot = form.querySelector("[data-bbqr-preview-mobile-slot]");
      const previewTrack = root.querySelector("[data-bbqr-preview-track]");
      const previewTabs = Array.from(root.querySelectorAll("[data-bbqr-preview-tab]"));
      const previewPreviousButton = root.querySelector("[data-bbqr-preview-previous]");
      const previewNextButton = root.querySelector("[data-bbqr-preview-next]");
      const previewStatus = root.querySelector("[data-bbqr-preview-status]");
      const configurationBlock = root.querySelector('[id^="BbqrGiftConfigure-"]');
      const finalCallToAction = root.querySelector(".bbqr-gift-final");
      const configurationLinks = Array.from(root.querySelectorAll('a[href="#' + configurationBlock?.id + '"]'));
      const scrollToConfiguration = (event) => {
        if (!configurationBlock) return;
        event.preventDefault();
        event.stopPropagation();
        const headerHeight = document.getElementById("section-header")?.getBoundingClientRect().height || 100;
        const top = configurationBlock.getBoundingClientRect().top + window.scrollY - headerHeight - 20;
        window.scrollTo({ top: Math.max(0, top), behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" });
      };
      configurationLinks.forEach((link) => link.addEventListener("click", scrollToConfiguration));

      const mobileSticky = root.querySelector("[data-bbqr-gift-mobile-sticky]");
      const mobileStickyPrice = root.querySelector("[data-bbqr-gift-sticky-price]");
      const compactPreviewQuery = window.matchMedia("(max-width: 980px)");
      const mobileStickyQuery = window.matchMedia("(max-width: 640px)");
      const reducedMotionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
      let previewIndex = 0;
      let previewScrollFrame;
      let stickyScrollFrame;
      let activeFixedCourseBegin = null;
      let activeFixedCourseLabel = "";

      const latestShippingISODate = () => {
        const latest = localISODate(maxScheduleDays);
        if (form.dataset.bbqrGiftMode !== "fixed" || !activeFixedCourseBegin) return latest;
        const [year, month, day] = activeFixedCourseBegin.date.split("-").map(Number);
        const scheduledOnCourseDay = berlinTimestamp(year, month, day, 8, 0);
        const courseLimit = scheduledOnCourseDay !== null && scheduledOnCourseDay < activeFixedCourseBegin.timestamp
          ? activeFixedCourseBegin.date : shiftISODate(activeFixedCourseBegin.date, -1);
        return courseLimit < latest ? courseLimit : latest;
      };
      const fixedShippingError = () => {
        if (form.dataset.bbqrGiftMode !== "fixed") return "";
        if (!activeFixedCourseLabel) return variantInput?.value ? dateInput?.dataset.courseDateMissingError || "" : "";
        if (!activeFixedCourseBegin) return dateInput?.dataset.courseDateMissingError || "";
        let effectiveSendTime = Date.now();
        const scheduled = selectedValue(deliveryInputs) === "Direkt an Beschenkten" && selectedValue(timingInputs) === "scheduled";
        if (scheduled && dateInput?.value) {
          const [year, month, day] = dateInput.value.split("-").map(Number);
          const requestedSendTime = berlinTimestamp(year, month, day, 8, 0);
          if (requestedSendTime !== null) effectiveSendTime = Math.max(effectiveSendTime, requestedSendTime);
        }
        return effectiveSendTime < activeFixedCourseBegin.timestamp ? "" : dateInput?.dataset.courseDateError || "";
      };

      const previewCourseNames = Array.from(root.querySelectorAll("[data-bbqr-preview-course]"));
      const previewCourseDates = Array.from(root.querySelectorAll("[data-bbqr-preview-date]"));
      const previewCourseDateOnly = Array.from(root.querySelectorAll("[data-bbqr-preview-date-only]"));
      const previewCourseTimes = Array.from(root.querySelectorAll("[data-bbqr-preview-time]"));
      const syncCoursePreview = () => {
        const courseName = selectedCourse?.textContent || "";
        const courseDate = selectedDate?.textContent || "";
        previewCourseNames.forEach((field) => {
          field.textContent = courseName || field.dataset.placeholder || "";
          if (field.classList.contains("bbqr-gift-preview__a4-course")) field.classList.toggle("is-long", field.textContent.length > 55);
        });
        previewCourseDates.forEach((field) => { field.textContent = courseDate; });
        previewCourseDateOnly.forEach((field) => { field.textContent = courseDate.match(/\b\d{2}\.\d{2}\.\d{4}\b/)?.[0] || field.dataset.placeholder || ""; });
        previewCourseTimes.forEach((field) => { field.textContent = courseDate.match(/\b\d{1,2}:\d{2}\b/)?.[0] || field.dataset.placeholder || ""; });
      };

      const updatePersonalPreview = () => {
        const updateFields = (fields, input) => {
          fields.forEach((field) => {
            field.textContent = input?.value.trim() || field.dataset.placeholder || "";
            field.closest(".bbqr-gift-preview__a4-personal")?.classList.toggle("is-long", (input?.value.trim().length || 0) > 45);
          });
        };

        updateFields(previewForNames, forNameInput);
        updateFields(previewFromNames, fromNameInput);
      };

      const syncStickyPrice = () => {
        if (!mobileStickyPrice) return;
        const currentPrice = priceValue?.textContent.trim();
        mobileStickyPrice.textContent = currentPrice && currentPrice !== "–"
          ? currentPrice
          : mobileStickyPrice.dataset.defaultPrice || "";
      };

      const setStickyVisibility = (visible) => {
        if (!mobileSticky) return;
        mobileSticky.classList.toggle("is-visible", visible);
        mobileSticky.setAttribute("aria-hidden", visible ? "false" : "true");
        document.body.classList.toggle("bbqr-mobile-sticky-visible", visible);

        if (visible) {
          const height = Math.ceil(mobileSticky.getBoundingClientRect().height);
          document.documentElement.style.setProperty("--bbqr-gift-mobile-sticky-height", `${height}px`);
        }
      };

      const updateStickyVisibility = () => {
        stickyScrollFrame = undefined;
        if (!mobileSticky || !configurationBlock || !finalCallToAction || !mobileStickyQuery.matches) {
          setStickyVisibility(false);
          return;
        }

        const configurationPassed = configurationBlock.getBoundingClientRect().bottom <= 0;
        const finalCallToActionReached = finalCallToAction.getBoundingClientRect().top <= window.innerHeight;
        setStickyVisibility(configurationPassed && !finalCallToActionReached);
      };

      const scheduleStickyUpdate = () => {
        if (stickyScrollFrame) return;
        stickyScrollFrame = window.requestAnimationFrame(updateStickyVisibility);
      };

      const updateModeButtons = (mode) => {
        previewKinds.forEach((example) => {
          example.hidden = example.dataset.bbqrPreviewKind !== (mode === "flexible" ? "flex" : "fixed");
        });
        flexibleModeButton?.setAttribute("aria-pressed", mode === "flexible" ? "true" : "false");
        fixedModeButton?.setAttribute("aria-pressed", mode === "fixed" ? "true" : "false");
      };

      const positionPreview = () => {
        if (!previewBlock || !previewHome || !previewMobileSlot) return;
        const target = compactPreviewQuery.matches ? previewMobileSlot : previewHome;
        if (previewBlock.parentElement !== target) target.appendChild(previewBlock);
      };

      const syncPreviewTrackHeight = () => {
        const activePanel = previewPanels[previewIndex];
        if (!previewTrack || !activePanel) return;
        previewTrack.style.height = `${activePanel.scrollHeight}px`;
      };

      const updatePreviewNavigation = (index) => {
        if (previewPanels.length === 0) return;

        previewIndex = Math.min(Math.max(index, 0), previewPanels.length - 1);
        previewPanels.forEach((panel, panelIndex) => {
          panel.setAttribute("aria-hidden", panelIndex === previewIndex ? "false" : "true");
        });
        previewTabs.forEach((tab, tabIndex) => {
          const selected = tabIndex === previewIndex;
          tab.setAttribute("aria-selected", selected ? "true" : "false");
          tab.tabIndex = selected ? 0 : -1;
        });

        if (previewStatus) previewStatus.textContent = `${previewIndex + 1} / ${previewPanels.length}`;
        if (previewPreviousButton) previewPreviousButton.disabled = previewIndex === 0;
        if (previewNextButton) previewNextButton.disabled = previewIndex === previewPanels.length - 1;
        window.requestAnimationFrame(syncPreviewTrackHeight);
      };

      const setPreview = (format, behavior = "smooth") => {
        const requestedIndex = previewPanels.findIndex((panel) => panel.dataset.bbqrPreview === format);
        const nextIndex = requestedIndex >= 0 ? requestedIndex : 0;
        updatePreviewNavigation(nextIndex);

        if (!previewTrack) return;
        previewTrack.scrollTo({
          left: previewTrack.clientWidth * nextIndex,
          behavior: reducedMotionQuery.matches ? "auto" : behavior,
        });
      };

      const movePreview = (step, focusTab = false) => {
        const nextIndex = Math.min(Math.max(previewIndex + step, 0), previewPanels.length - 1);
        const nextFormat = previewPanels[nextIndex]?.dataset.bbqrPreview || "DIN A4 quer";
        setPreview(nextFormat);
        if (focusTab) previewTabs[nextIndex]?.focus({ preventScroll: true });
      };

      const resetSummaryMessage = () => {
        if (!summary) return;
        summary.textContent = summary.dataset.defaultText || "";
        summary.hidden = true;
      };

      const setMoreDatesState = (button, expanded) => {
        if (!button) return;
        const card = button.closest("[data-bbqr-course-card]");
        if (!card) return;

        card.querySelectorAll("[data-bbqr-extra-date]").forEach((option) => {
          option.hidden = !expanded;
        });
        button.setAttribute("aria-expanded", expanded ? "true" : "false");
        button.textContent = expanded ? button.dataset.lessLabel || "" : button.dataset.moreLabel || "";
      };

      const resetCourseCards = () => {
        fixedCourseSelectors.forEach((selector) => {
          selector.setAttribute("aria-pressed", "false");
          selector.classList.remove("is-selected");
          delete selector.dataset.bbqrCommitted;
        });
        fixedCourseConfirmButtons.forEach((button) => {
          button.disabled = true;
        });
        fixedCourseMoreButtons.forEach((button) => setMoreDatesState(button, false));
        root.querySelectorAll("[data-bbqr-course-card]").forEach((card) => card.classList.remove("is-selected"));
      };

      const selectFixedOption = (selector) => {
        if (!selector) return;
        const selectedCard = selector.closest("[data-bbqr-course-card]");

        fixedCourseSelectors.forEach((courseSelector) => {
          const selected = courseSelector === selector;
          courseSelector.setAttribute("aria-pressed", selected ? "true" : "false");
          courseSelector.classList.toggle("is-selected", selected);
          delete courseSelector.dataset.bbqrCommitted;
        });
        root.querySelectorAll("[data-bbqr-course-card]").forEach((card) => {
          card.classList.toggle("is-selected", card === selectedCard);
        });
        fixedCourseConfirmButtons.forEach((button) => {
          button.disabled = button.closest("[data-bbqr-course-card]") !== selectedCard;
        });

        if (variantInput) variantInput.value = "";
        if (productIdInput) productIdInput.value = "";
        if (giftTypeInput) giftTypeInput.value = "Grillkurs mit festem Termin";
        if (submitButton) submitButton.disabled = true;
        updateModeButtons("fixed");
        form.dataset.bbqrGiftMode = "fixed";
        form.dataset.bbqrCartState = "waiting";
        form.dataset.bbqrProductState = "waiting";
        activeFixedCourseLabel = selector.dataset.date || "";
        activeFixedCourseBegin = parseCourseBegin(activeFixedCourseLabel);
        updateDelivery();
      };

      const showCourseChoices = (focusCourse = true) => {
        if (!fixedCourses || fixedCourseSelectors.length === 0) return;
        fixedCourses.hidden = false;
        const activeCourse = (
          fixedCourseSelectors.find((selector) => selector.dataset.bbqrCommitted === "true")
          || fixedCourseSelectors.find((selector) => selector.getAttribute("aria-pressed") === "true")
        );
        if (activeCourse?.hidden) {
          setMoreDatesState(activeCourse.closest("[data-bbqr-course-card]")?.querySelector("[data-bbqr-more-dates]"), true);
        }
        if (focusCourse) (activeCourse || fixedCourseSelectors[0])?.focus({ preventScroll: true });
      };

      const setFlexibleMode = () => {
        if (variantInput) {
          variantInput.value = variantInput.dataset.flexibleVariantId || "";
        }
        if (productIdInput && variantInput) {
          productIdInput.value = variantInput.dataset.flexibleProductId || "";
        }
        if (giftTypeInput) {
          giftTypeInput.value = "Flexibler Grillkurs-Geschenkgutschein";
        }
        if (flexibleMode) flexibleMode.hidden = false;
        if (fixedMode) fixedMode.hidden = true;
        if (fixedCourses) fixedCourses.hidden = true;
        if (purchaseLead) purchaseLead.textContent = purchaseLead.dataset.flexibleText || "";
        if (priceLabel) priceLabel.textContent = priceLabel.dataset.flexibleText || "";
        if (priceValue) priceValue.textContent = priceValue.dataset.flexiblePrice || "";
        if (submitButton) {
          submitButton.textContent = submitButton.dataset.flexibleLabel || "";
          submitButton.disabled = submitButton.dataset.flexibleAvailable !== "true";
        }
        updateModeButtons("flexible");
        resetCourseCards();
        activeFixedCourseLabel = "";
        activeFixedCourseBegin = null;
        form.dataset.bbqrGiftMode = "flexible";
        form.dataset.bbqrCartState = (
          variantInput
          && giftTypeInput
          && variantInput.value === variantInput.dataset.flexibleVariantId
          && giftTypeInput.value === "Flexibler Grillkurs-Geschenkgutschein"
        ) ? "ready" : "error";
        form.dataset.bbqrProductState = (
          !productIdInput
          || (variantInput && productIdInput.value === variantInput.dataset.flexibleProductId)
        ) ? "ready" : "error";
        syncStickyPrice();
        resetSummaryMessage();
        updateDelivery();
      };

      const setDirectMode = (focusCourse = false) => {
        if (fixedCourseSelectors.length === 0) {
          setFlexibleMode();
          return;
        }

        if (variantInput) variantInput.value = "";
        if (productIdInput) productIdInput.value = "";
        if (giftTypeInput) giftTypeInput.value = "Grillkurs mit festem Termin";
        if (flexibleMode) flexibleMode.hidden = true;
        if (fixedMode) fixedMode.hidden = false;
        if (selectedCourse) selectedCourse.textContent = selectedCourse.dataset.emptyText || "";
        if (selectedDetails) selectedDetails.hidden = true;
        if (selectedDate) selectedDate.textContent = "";
        if (selectedPrice) selectedPrice.textContent = "";
        if (selectedStock) {
          selectedStock.textContent = "";
          selectedStock.hidden = true;
        }
        if (selectedCopy) selectedCopy.textContent = selectedCopy.dataset.emptyText || "";
        if (courseActions) courseActions.hidden = true;
        if (purchaseLead) purchaseLead.textContent = purchaseLead.dataset.fixedText || "";
        if (priceLabel) priceLabel.textContent = priceLabel.dataset.emptyText || "";
        if (priceValue) priceValue.textContent = priceValue.dataset.emptyPrice || "–";
        if (submitButton) {
          submitButton.textContent = submitButton.dataset.fixedEmptyLabel || "";
          submitButton.disabled = true;
        }
        resetCourseCards();
        activeFixedCourseLabel = "";
        activeFixedCourseBegin = null;
        syncCoursePreview();
        updateModeButtons("fixed");
        form.dataset.bbqrGiftMode = "fixed";
        form.dataset.bbqrCartState = "waiting";
        form.dataset.bbqrProductState = "waiting";
        syncStickyPrice();
        resetSummaryMessage();
        showCourseChoices(focusCourse);
        updateDelivery();
      };

      const setFixedMode = (selector) => {
        if (!selector || !variantInput || !giftTypeInput) return;

        selectFixedOption(selector);
        variantInput.value = selector.dataset.variantId || "";
        giftTypeInput.value = "Grillkurs mit festem Termin";
        if (productIdInput) productIdInput.value = selector.dataset.productId || "";
        if (flexibleMode) flexibleMode.hidden = true;
        if (fixedMode) fixedMode.hidden = false;
        if (selectedCourse) selectedCourse.textContent = selector.dataset.course || "";
        if (selectedDate) selectedDate.textContent = selector.dataset.date || "";
        if (selectedPrice) selectedPrice.textContent = selector.dataset.price || "";
        if (selectedDetails) selectedDetails.hidden = false;
        if (selectedStock) {
          selectedStock.textContent = selector.dataset.stockMessage || "";
          selectedStock.hidden = !selector.dataset.stockMessage;
        }
        if (selectedCopy) selectedCopy.textContent = selectedCopy.dataset.selectedText || "";
        if (courseActions) courseActions.hidden = false;
        if (purchaseLead) purchaseLead.textContent = purchaseLead.dataset.fixedText || "";
        if (priceLabel) priceLabel.textContent = priceLabel.dataset.fixedText || "";
        if (priceValue) priceValue.textContent = selector.dataset.price || "";
        if (submitButton) {
          submitButton.textContent = submitButton.dataset.fixedLabel || "";
          submitButton.disabled = false;
        }
        updateModeButtons("fixed");
        syncCoursePreview();
        selector.dataset.bbqrCommitted = "true";
        form.dataset.bbqrGiftMode = "fixed";
        form.dataset.bbqrCartState = (
          variantInput.value === selector.dataset.variantId
          && giftTypeInput.value === "Grillkurs mit festem Termin"
        ) ? "ready" : "error";
        form.dataset.bbqrProductState = (
          !productIdInput
          || productIdInput.value === selector.dataset.productId
        ) ? "ready" : "error";
        if (fixedCourses) fixedCourses.hidden = true;
        syncStickyPrice();
        resetSummaryMessage();
      };

      const selectedValue = (inputs) => {
        const selected = inputs.find((input) => input.checked);
        return selected ? selected.value : "";
      };

      const updatePreview = () => {
        const format = selectedValue(formatInputs);
        setPreview(format, "auto");
      };

      const updateDelivery = () => {
        const direct = selectedValue(deliveryInputs) === "Direkt an Beschenkten";
        const scheduled = direct && selectedValue(timingInputs) === "scheduled";

        if (directPanel) directPanel.hidden = !direct;

        if (recipientEmail) {
          recipientEmail.required = direct;
          recipientEmail.setAttribute("aria-required", direct ? "true" : "false");
          recipientEmail.setCustomValidity("");
          if (!direct) recipientEmail.value = "";
        }

        if (dateWrap) dateWrap.hidden = !scheduled;

        if (dateInput) {
          dateInput.min = localISODate();
          dateInput.max = latestShippingISODate();
          dateInput.required = scheduled;
          dateInput.setAttribute("aria-required", scheduled ? "true" : "false");
          dateInput.setCustomValidity("");
          if (!scheduled) dateInput.value = "";
          if (scheduled && dateInput.value) dateInput.setCustomValidity(fixedShippingError());
        }
      };

      const updateMessageCount = () => {
        if (!messageInput || !messageCount) return;
        messageCount.textContent = `${messageInput.value.length} / ${messageInput.maxLength}`;
      };

      const validateForm = () => {
        trimRequiredInputs.forEach((input) => {
          const message = input.dataset.requiredMessage || "";
          input.setCustomValidity(input.value.trim() ? "" : message);
        });

        if (recipientEmail && recipientEmail.required && !recipientEmail.value.trim()) {
          recipientEmail.setCustomValidity(recipientEmail.dataset.requiredMessage || "");
        }

        if (dateInput && dateInput.required) {
          const earliestDate = localISODate();
          const latestDate = latestShippingISODate();
          const invalidDate = (
            !dateInput.value
            || dateInput.value < earliestDate
            || dateInput.value > latestDate
          );
          dateInput.setCustomValidity(fixedShippingError() || (invalidDate ? dateInput.dataset.dateError || "" : ""));
        }

        return form.checkValidity();
      };

      formatInputs.forEach((input) => input.addEventListener("change", updatePreview));
      previewTabs.forEach((tab, tabIndex) => {
        tab.addEventListener("click", () => {
          setPreview(tab.dataset.bbqrPreviewTab || "DIN A4 quer");
        });
        tab.addEventListener("keydown", (event) => {
          if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return;
          event.preventDefault();

          if (event.key === "Home") {
            setPreview(previewPanels[0]?.dataset.bbqrPreview || "DIN A4 quer");
            previewTabs[0]?.focus({ preventScroll: true });
            return;
          }

          if (event.key === "End") {
            const lastIndex = previewPanels.length - 1;
            setPreview(previewPanels[lastIndex]?.dataset.bbqrPreview || "DIN lang");
            previewTabs[lastIndex]?.focus({ preventScroll: true });
            return;
          }

          const direction = event.key === "ArrowRight" ? 1 : -1;
          previewIndex = tabIndex;
          movePreview(direction, true);
        });
      });
      previewPreviousButton?.addEventListener("click", () => movePreview(-1));
      previewNextButton?.addEventListener("click", () => movePreview(1));

      previewTrack?.addEventListener("scroll", () => {
        window.cancelAnimationFrame(previewScrollFrame);
        previewScrollFrame = window.requestAnimationFrame(() => {
          if (!previewTrack.clientWidth) return;
          updatePreviewNavigation(Math.round(previewTrack.scrollLeft / previewTrack.clientWidth));
        });
      }, { passive: true });

      root.querySelectorAll(".bbqr-gift-preview__image").forEach((image) => {
        if (!image.complete) image.addEventListener("load", syncPreviewTrackHeight, { once: true });
      });
      if (typeof ResizeObserver === "function") {
        const previewResizeObserver = new ResizeObserver(syncPreviewTrackHeight);
        previewPanels.forEach((panel) => previewResizeObserver.observe(panel));
      }

      deliveryInputs.forEach((input) => input.addEventListener("change", updateDelivery));
      timingInputs.forEach((input) => input.addEventListener("change", updateDelivery));
      trimRequiredInputs.forEach((input) => {
        input.addEventListener("input", () => {
          input.setCustomValidity("");
          input.removeAttribute("aria-invalid");
        });
      });

      if (recipientEmail) {
        recipientEmail.addEventListener("input", () => {
          recipientEmail.setCustomValidity("");
          recipientEmail.removeAttribute("aria-invalid");
        });
      }

      if (dateInput) {
        dateInput.addEventListener("input", () => {
          dateInput.setCustomValidity("");
          dateInput.removeAttribute("aria-invalid");
          if (dateInput.required && dateInput.value) dateInput.setCustomValidity(fixedShippingError());
        });
      }

      if (messageInput) {
        messageInput.addEventListener("input", updateMessageCount);
      }

      forNameInput?.addEventListener("input", updatePersonalPreview);
      fromNameInput?.addEventListener("input", updatePersonalPreview);

      if (flexibleModeButton) {
        flexibleModeButton.addEventListener("click", setFlexibleMode);
      }

      if (fixedModeButton) {
        fixedModeButton.addEventListener("click", () => {
          const activeCourse = (
            fixedCourseSelectors.find((selector) => selector.dataset.bbqrCommitted === "true")
            || fixedCourseSelectors.find((selector) => selector.getAttribute("aria-pressed") === "true")
          );
          if (activeCourse) {
            showCourseChoices(true);
          } else {
            setDirectMode(true);
          }
        });
      }

      if (changeCourseButton) {
        changeCourseButton.addEventListener("click", () => showCourseChoices(true));
      }

      if (removeCourseButton) {
        removeCourseButton.addEventListener("click", () => setDirectMode(true));
      }

      fixedCourseSelectors.forEach((selector) => {
        selector.addEventListener("click", () => selectFixedOption(selector));
      });

      fixedCourseConfirmButtons.forEach((button) => {
        button.addEventListener("click", () => {
          const selectedOption = button
            .closest("[data-bbqr-course-card]")
            ?.querySelector('[data-bbqr-fixed-option][aria-pressed="true"]');
          if (selectedOption) setFixedMode(selectedOption);
        });
      });

      fixedCourseMoreButtons.forEach((button) => {
        button.addEventListener("click", () => {
          setMoreDatesState(button, button.getAttribute("aria-expanded") !== "true");
        });
      });

      form.addEventListener("invalid", (event) => {
        event.target.setAttribute("aria-invalid", "true");
        if (summary) {
          summary.textContent = summary.dataset.defaultText || "";
          summary.hidden = false;
        }
      }, true);

      form.addEventListener("submit", (event) => {
        if (summary) summary.hidden = true;

        if (form.dataset.bbqrCartState !== "ready" || form.dataset.bbqrProductState !== "ready") {
          event.preventDefault();
          if (summary) {
            summary.textContent = summary.dataset.selectionText || "";
            summary.hidden = false;
          }
          if (form.dataset.bbqrGiftMode === "fixed") showCourseChoices(false);
          fixedModeButton?.focus({ preventScroll: true });
          return;
        }

        const shippingError = fixedShippingError();
        if (shippingError) {
          event.preventDefault();
          if (summary) {
            summary.textContent = shippingError;
            summary.hidden = false;
          }
          if (dateInput?.required) {
            dateInput.setCustomValidity(shippingError);
            dateInput.focus();
            form.reportValidity();
          } else {
            fixedModeButton?.focus({ preventScroll: true });
          }
          return;
        }

        if (!validateForm()) {
          event.preventDefault();
          if (summary) {
            summary.textContent = summary.dataset.defaultText || "";
            summary.hidden = false;
          }
          const firstInvalid = form.querySelector(":invalid");
          if (firstInvalid) firstInvalid.focus();
          form.reportValidity();
          return;
        }

        if (submitButton) submitButton.setAttribute("aria-busy", "true");
      });

      compactPreviewQuery.addEventListener("change", () => {
        positionPreview();
        window.requestAnimationFrame(() => {
          const currentFormat = previewPanels[previewIndex]?.dataset.bbqrPreview || "DIN A4 quer";
          setPreview(currentFormat, "auto");
        });
      });
      window.addEventListener("scroll", scheduleStickyUpdate, { passive: true });
      window.addEventListener("resize", scheduleStickyUpdate, { passive: true });
      window.addEventListener("orientationchange", scheduleStickyUpdate, { passive: true });
      mobileStickyQuery.addEventListener("change", scheduleStickyUpdate);

      root.bbqrGiftCleanup = () => {
        configurationLinks.forEach((link) => link.removeEventListener("click", scrollToConfiguration));
        window.removeEventListener("scroll", scheduleStickyUpdate);
        window.removeEventListener("resize", scheduleStickyUpdate);
        window.removeEventListener("orientationchange", scheduleStickyUpdate);
        mobileStickyQuery.removeEventListener("change", scheduleStickyUpdate);
        window.cancelAnimationFrame(stickyScrollFrame);
        setStickyVisibility(false);
      };

      positionPreview();
      if (fixedCourseSelectors.length > 0) {
        setDirectMode(false);
      } else {
        setFlexibleMode();
      }
      updatePreview();
      updateDelivery();
      updateMessageCount();
      updatePersonalPreview();
      syncStickyPrice();
      scheduleStickyUpdate();
    };

    const initializeAllGiftSections = (scope = document) => {
      scope.querySelectorAll("[data-bbqr-gift]").forEach(initializeGiftSection);
    };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => initializeAllGiftSections());
    } else {
      initializeAllGiftSections();
    }

    document.addEventListener("shopify:section:load", (event) => {
      initializeAllGiftSections(event.target);
    });

    document.addEventListener("shopify:section:unload", (event) => {
      event.target.querySelectorAll("[data-bbqr-gift]").forEach((root) => {
        root.bbqrGiftCleanup?.();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    if (window.bbqrCookiePreferencesBound) return;
    window.bbqrCookiePreferencesBound = true;

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-bbqr-cookie-preferences]');
      if (!trigger) return;
      if (!window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') return;

      event.preventDefault();

      try {
        const openPreferences = window.privacyBanner.showPreferences();

        if (openPreferences && typeof openPreferences.catch === 'function') {
          openPreferences.catch(() => {
            window.location.assign(trigger.href);
          });
        }
      } catch {
        window.location.assign(trigger.href);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
